import { Component } from '@angular/core';

import { AlertModalService } from '../../service/alert-modal.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-alert-modal',
    templateUrl: './alert-modal.component.html',
    styleUrls: ['./alert-modal.component.scss'],
    standalone: true,
    imports: [NgIf, TranslateModule]
})
export class AlertModalComponent {

  error: any = null;

  constructor(
    private alertService: AlertModalService
  ) { }

  isDisplayed() {
    const flag = this.alertService.hasError();
    if ( flag && this.error === null ) {
      this.error = this.alertService.getError();
    }
    return flag;
  }

  onAbort() {
    this.alertService.releaseError();
    this.error = null;
  }

  onConfirm(url: string) {
    this.alertService.releaseError();
    this.error = null;
    if ( !!url ) {
      location.replace(url);
    }
  }

}
